import Store from "./Store";
import Base from "./Base";

export default class Gemeente extends Base {
  provincieId: string;
  regioId: string;

  center: [number, number];

  constructor(store: Store, f: any) {
    super(store);
    this.type = "g";
    this.id = f.properties.id + "";
    this.name = f.properties.name;
    this.provincieId = f.properties.pid + "";
    this.regioId = f.properties.vid + "";
    this.geometry = f.geometry;
    this.center = [f.properties.lon, f.properties.lat];
    this.inhabitants = f.properties.Inwonertal || 0;
    this.surface = f.properties.oppervlak;
  }
}
